import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styles from "./Landing.module.css";

const defaultPlaceholderBlogs = [
  {
    title: "Best Desk Stretches According to Physical Therapists",
    url: "https://www.choosept.com/guide/physical-therapy-guide",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
    body: "Sitting for long hours? These stretches, recommended by physiotherapy experts, help boost blood flow, improve posture and can be done anywhere to reduce chronic aches.",
    source: "Choose PT",
    time: "Mon",
  },
  {
    title: "The Science Behind Sports Recovery & Rehab",
    url: "https://www.physio-pedia.com/Sports_Physiotherapy",
    image: "https://images.unsplash.com/photo-1454023492550-5696f8ff10e1?auto=format&fit=crop&w=600&q=80",
    body: "Physiotherapists are crucial in every athlete’s recovery—by customizing programs that blend manual therapy, modalities, and training techniques to maximize performance.",
    source: "Physio-Pedia",
    time: "Wed",
  },
  {
    title: "Understanding Posture Correctors: Myth vs Reality",
    url: "https://www.moveforwardpt.com",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=600&q=80",
    body: "Do wearable posture braces actually work? Our physical therapists break down the biomechanics of spinal alignment and explain why active core strengthening wins.",
    source: "ReformMe Rehab",
    time: "Fri",
  },
];

const BlogGrid = ({ blogs, doctorBlogs }) => {
  // Combine placeholder blogs with any real API doctorBlogs passed down
  const displayList = (doctorBlogs && doctorBlogs.length > 0)
    ? doctorBlogs.map(b => ({
        title: b.headTitle || "Doctor Article",
        url: "#",
        image: b.image || "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
        body: b.body || "",
        source: b.author || "ReformMe Doctor",
        time: "Recent",
        isVideo: b.image && b.image.match(/\.(mp4|webm|ogg|mov|avi)$/i)
      }))
    : (blogs || defaultPlaceholderBlogs);

  return (
    <section className={styles.blogGridSection}>
      <div className={styles.sectionHeading}>
        <span className={styles.sectionTag}>HEALTHCARE INSIGHTS</span>
        <h2 className={styles.sectionTitle}>Latest Articles & Physiotherapy Guides</h2>
      </div>

      <div className={styles.blogGrid}>
        {displayList.map((item, index) => (
          <a
            key={item._id || index}
            href={item.url}
            target={item.url !== "#" ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className={styles.blogCard}
          >
            <div className={styles.blogCardImage}>
              {item.isVideo ? (
                <video src={item.image} controls style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <img src={item.image} alt={item.title} />
              )}
            </div>

            <div className={styles.blogCardContent}>
              <div className={styles.blogCardMeta}>
                <span>{item.source}</span>
                <span>
                  <FontAwesomeIcon icon={faClock} /> {item.time}
                </span>
              </div>

              <h3 className={styles.blogCardTitle}>
                {item.title.length > 55 ? item.title.slice(0, 55) + "…" : item.title}
              </h3>

              <p className={styles.blogCardDesc}>
                {item.body.length > 110 ? item.body.slice(0, 110) + "…" : item.body}
              </p>

              <div style={{ color: "#2d6a4f", fontWeight: 700, fontSize: "0.9rem", display: "flex", alignItems: "center", gap: "0.4rem", marginTop: "auto" }}>
                <span>Read Guide</span>
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default BlogGrid;
